import React from "react";
import { Play, Bell, X } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "../ui/dialog";

export const DemoDialog = ({ open, onOpenChange, onJoinClick }) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        data-testid="demo-dialog"
        className="bg-[#0A0A0A] border-[#27272A] text-white rounded-sm max-w-2xl p-0 overflow-hidden"
      >
        <div className="relative aspect-video bg-[#141414] border-b border-[#27272A] overflow-hidden">
          <div className="absolute inset-0 bg-grid opacity-30" />
          <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-6">
            <div className="w-16 h-16 grid place-items-center bg-[#FF6B00] text-black rounded-sm metal-edge mb-5">
              <Play className="w-7 h-7" fill="currentColor" />
            </div>
            <div className="font-mono-spec text-[10px] uppercase tracking-[0.28em] text-[#FF6B00] mb-3">
              ● Recording Soon
            </div>
            <div className="font-display text-2xl md:text-3xl tracking-tight">
              Product Demo · Coming Soon
            </div>
          </div>
          <div className="absolute top-4 left-4 font-mono-spec text-[10px] uppercase tracking-[0.25em] text-[#A1A1AA]">
            REC · AG-PRO-01
          </div>
          <div className="absolute top-4 right-4 font-mono-spec text-[10px] uppercase tracking-[0.25em] text-[#A1A1AA]">
            00:00 / —:—
          </div>
        </div>

        <div className="p-6 md:p-8">
          <DialogHeader className="text-left">
            <DialogTitle className="font-display text-2xl md:text-3xl tracking-tight">
              The full demo is on the way.
            </DialogTitle>
            <DialogDescription className="text-[#A1A1AA] text-base mt-3 leading-relaxed">
              We&apos;re filming the AdjustaGland PRO demo with real electricians, on a
              real bench. Join the waiting list and we&apos;ll send it straight to your
              inbox the day it goes live.
            </DialogDescription>
          </DialogHeader>

          <div className="mt-7 flex flex-col sm:flex-row gap-3">
            <button
              data-testid="demo-dialog-join-btn"
              onClick={() => {
                onOpenChange(false);
                onJoinClick();
              }}
              className="btn-primary flex-1"
            >
              <Bell className="w-4 h-4" /> Notify Me When Live
            </button>
            <button
              data-testid="demo-dialog-close-btn"
              onClick={() => onOpenChange(false)}
              className="btn-secondary"
            >
              <X className="w-4 h-4" /> Close
            </button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
